import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';
import styles from './Filters.scss';
import intersection from 'lodash.intersection';

import Menu from '../../../common/Menu/Menu';
import Dropdown from '../../../common/Dropdown/Dropdown';
import Area, { subtext as areaSubtext } from 'components/Header/FiltersBar/Filters/Area/Area';
import Price, { subtext as priceSubtext } from 'components/Header/FiltersBar/Filters/Price/Price';
import Interior, { subtext as interiorSubtext } from 'components/Header/FiltersBar/Filters/Interior/Interior';
import ViewTypes, { subtext as viewTypeSubtext } from 'components/Header/FiltersBar/Filters/ViewType/ViewType';

import { compileQuery } from 'utils';
import debounce from 'lodash.debounce';

import tracker from '../../../../services/tracker';
import { isReserved } from '../../../../helper';


class Filters extends Component {

  getFilters = (
    filters = {
      interior: null,
      costMin: null,
      costMax: null,
      priceMin: null,
      priceMax: null,
      areaFrom: null,
      areaTo: null,
      view_type: null
    },
    request,
  ) => {
    const { location, handleFilters, history } = this.props;
    const { pathname, search } = location;
    const query = compileQuery(filters, search);
    const newSearch = query ? `?${query}` : '';
    const path = `${pathname}${newSearch}`;
    history.push(path);

    handleFilters(request);
  }

  getFiltersDebounced = debounce(this.getFilters, 1000)

  render() {
    const { className, print, search = {}, cells, eventData, t } = this.props;

    const interiorsInHouse = cells.reduce(
      (list, cell) => {
        if (cell.data.status === 'saleStatus' || isReserved(cell.data.status) || cell.data.status === 'assignmentStatus') {
          return list.includes(cell.data.interior) ? list : [cell.data.interior, ...list];
        }
        return list;
      },
      ([])
    );
    const splitedInterior = search.interior && search.interior.length ? search.interior.split(',') : [];
    const interiorIntersection = intersection(interiorsInHouse, splitedInterior);
    const filteredIntersection = interiorIntersection.length ? interiorIntersection.join(',') : null;

    return (
      <div className={cn(styles.Filters, { [styles.FiltersPrint]: print }, styles.FiltersChess, className)}>
        <Dropdown
          text={t('components.building.filters.price')}
          subtext={(search.priceMin || search.priceMax || search.costMin || search.costMax) ? priceSubtext(search) : null}
          className={cn(styles.Filter, styles.FilterPrice, { [styles.Active]: search.priceMin || search.priceMax || search.costMin || search.costMax })}
          buttonStyle={styles.Button}
          iconStyle={styles.DropdownIcon}
          textStyle={styles.Title}
          chessfilter
          filter={true}
          openByClick={true}
          onClick={() => tracker.sendEvent('Web_List_Filters_Price', eventData)}
        >
          <Menu chessfilter>
            <Price
              events={{
                left: 'Web_List_Filters_Price_General',
                right: 'Web_List_Filters_Price_Kv'
              }}
              eventData={eventData}
              dropdownData={this.getFiltersDebounced}
              search={search}
              chessfilter
            />
          </Menu>
        </Dropdown>
        <Dropdown
          text={t('components.building.filters.area')}
          subtext={(search.areaFrom || search.areaTo) ? areaSubtext(search) : null}
          className={cn(styles.Filter, { [styles.Active]: search.areaFrom || search.areaTo })}
          buttonStyle={styles.Button}
          iconStyle={styles.DropdownIcon}
          textStyle={styles.Title}
          chessfilter
          filter={true}
          openByClick={true}
          onClick={() => tracker.sendEvent('Web_List_Filters_Square', eventData)}
        >
          <Menu chessfilter>
            <Area dropdownData={this.getFiltersDebounced} search={search} chessfilter />
          </Menu>
        </Dropdown>
        <Dropdown
          text={t('components.building.filters.inter')}
          subtext={search.interior ? interiorSubtext({ interior: filteredIntersection }) : null}
          className={cn(styles.Filter, { [styles.Active]: filteredIntersection })}
          buttonStyle={styles.Button}
          iconStyle={styles.DropdownIcon}
          textStyle={styles.Title}
          // rightShift
          chessfilter
          filter={true}
          openByClick={true}
        >
          <Menu chessfilter>
            <Interior dropdownData={this.getFilters} search={search} chessfilter cells={cells} />
          </Menu>
        </Dropdown>
        <Dropdown
          text={t('components.header.filtersBar.filters.viewTypes.title')}
          subtext={search.view_type ? viewTypeSubtext(search) : null}
          className={cn(styles.Filter, { [styles.Active]: !!search.view_type })}
          buttonStyle={styles.Button}
          iconStyle={styles.DropdownIcon}
          textStyle={styles.Title}
          // rightShift
          chessfilter
          filter={true}
          openByClick={true}
        >
          <Menu chessfilter>
            <ViewTypes dropdownData={this.getFilters} search={search} chessfilter cells={cells} />
          </Menu>
        </Dropdown>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Filters));



// WEBPACK FOOTER //
// ./src/components/Building/Chess/Filters/Filters.js